import { render, staticRenderFns } from "./PurchaseOrderOverview.vue?vue&type=template&id=f8587d0c"
import script from "./PurchaseOrderOverview.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8587d0c')) {
      api.createRecord('f8587d0c', component.options)
    } else {
      api.reload('f8587d0c', component.options)
    }
    module.hot.accept("./PurchaseOrderOverview.vue?vue&type=template&id=f8587d0c", function () {
      api.rerender('f8587d0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/PurchaseOrderOverview.vue"
export default component.exports